import { gql } from '@apollo/client';
import { Cooperative } from 'cooperatives/models/cooperative';
import { FinancialAccountId } from 'financialAccounts/models/financialAccounts';

export interface CooperativeUpdateMutationInput {
  id: number;
  cooperativeSubscriptionCostCents: number;
  cooperativeLegalName: string;
  cooperativeDocumentId: string;
  cooperativeAddressPostalCode: number;
  cooperativeAddressState: string;
  cooperativeAddressCity: string;
  cooperativeAddressStreet: string;
  cooperativeAddressDistrict: string;
  cooperativeAddressComplement: string | null;
  financialAccountId: FinancialAccountId | null;
}

export interface CooperativeUpdateMutationVariables {
  cooperativeUpdateInput: CooperativeUpdateMutationInput;
}

export interface CooperativeUpdated {
  cooperativeUpdate: Cooperative;
}

export const COOPERATIVE_UPDATE_MUTATION = gql`
  mutation cooperativeUpdate($cooperativeUpdateInput: CooperativeUpdateInput!) {
    cooperativeUpdate(input: $cooperativeUpdateInput) {
      id
      cooperativeAddressCity
      cooperativeAddressPostalCode
      cooperativeAddressState
      cooperativeAddressStreet
      cooperativeAddressDistrict
      cooperativeAddressComplement
      cooperativeDocumentId
      cooperativeLegalName
      cooperativeSubscriptionCostCents
      financialAccount {
        id
        financialAccountLegalName
      }
    }
  }
`;
